import { getQueryParam } from './url';
export function getCookie(name, defaultValue = null) {
    const nameEQ = `${name}=`;
    const cookieItems = document.cookie.split(';');
    for (let i = 0; i < cookieItems.length; i++) {
        const cookieItem = cookieItems[i].trim();
        if (cookieItem.indexOf(nameEQ) === 0) {
            return decodeURIComponent(cookieItem.substring(nameEQ.length, cookieItem.length));
        }
    }
    return defaultValue;
}
/**
 * 是否为正式环境
 * @returns boolean
 */
export function isPrdEnv() {
    const PRD_HOSTNAMES = ['h5.tu.qq.com', 'h5.qzone.qq.com'];
    return PRD_HOSTNAMES.includes(window.location.host);
}
/**
 * 当url中存在 debug=1参数时,表示为调试模式
 * @returns 是否出于调试模式
 */
export function isDebugMode() {
    const debugFlag = getQueryParam('debug', '0');
    return !!debugFlag;
}
